module.exports = __webpack_public_path__ + "static/media/west-coast-eagles-logo.ced93d05.svg";